import React from "react";

const CompetenciesEmptyState = (): React.ReactElement => {
	return (
		<div className="flex h-full items-center justify-center p-8">
			<p className="text-gray-500">No competencies to display.</p>
		</div>
	);
};

export default CompetenciesEmptyState;
